import type { FC, ReactNode } from 'react'

import { BadgeCheck } from 'lucide-react'

import { cn } from '@/lib/utils'

/**
 * The acid TRUSTED sticker.
 *
 * It is the one lime thing in the composition and the only element allowed to
 * be, so it stays a signal rather than a decoration. Everything about it is
 * physical: a hard black rule, an offset block with no blur, and a tilt it
 * gets from the piece that holds it — a sticker slapped onto the board, not a
 * badge component.
 *
 * `--accent-acid-ink` is near-black on `--accent-acid`, so the label clears
 * contrast comfortably, and the check is paired with the word rather than
 * standing in for it.
 */

interface TrustedBadgeProps {
    className?: string
}

export const TrustedBadge: FC<TrustedBadgeProps> = ({ className }): ReactNode => {
    return (
        <div
            className={cn(
                'flex w-full items-center justify-center gap-[0.35em] rounded-[0.55em] border-2 border-ink-900 bg-acid px-[0.7em] py-[0.42em] shadow-offset',
                className
            )}
        >
            <BadgeCheck className='size-[1.1em] shrink-0 text-acid-ink' strokeWidth={2.8} aria-hidden='true' />

            <span className='hero-label whitespace-nowrap text-[1.05em] leading-none tracking-[0.02em] text-acid-ink'>
                Trusted
            </span>
        </div>
    )
}
